import { render, staticRenderFns } from "./myAskLeave.vue?vue&type=template&id=0f932ce4&"
import script from "./myAskLeave.vue?vue&type=script&lang=js&"
export * from "./myAskLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports